import type {
  ServiceSpec,
  ServiceTableSpec,
  TableActionSpec,
  TableHeaderSpec,
} from '@/@vxapp/@Types/ServiceMetadata'

function freezeHeaders(
  headers: ServiceTableSpec['headers']
): readonly TableHeaderSpec[] | undefined {
  return headers?.map(header => Object.freeze({ ...header }))
}

function freezeActions(
  actions: ServiceTableSpec['actions']
): readonly TableActionSpec[] | undefined {
  return actions?.map(action => {
    const frozenAction = action.route
      ? {
          ...action,
          route: Object.freeze({ ...action.route }),
        }
      : { ...action }

    return Object.freeze(frozenAction)
  })
}

function freezeTable(table: ServiceTableSpec | undefined): Readonly<ServiceTableSpec> | undefined {
  if (!table) {
    return undefined
  }

  return Object.freeze({
    ...table,
    headers: table.headers ? Object.freeze(freezeHeaders(table.headers) ?? []) : undefined,
    actions: table.actions ? Object.freeze(freezeActions(table.actions) ?? []) : undefined,
  })
}

export function defineServiceSpec<const TSpec extends ServiceSpec>(spec: TSpec): Readonly<TSpec> {
  return Object.freeze({
    ...spec,
    table: freezeTable(spec.table),
  }) as Readonly<TSpec>
}
